import React, { useState } from "react";
import Header from '../Component/common/Header/Header';
import Table from '../Component/common/Table/Table'; // adjust path if needed

const ImpLink = () => {
  const [links, setLinks] = useState([
    { id: 1, description: "Google", link: "https://google.com" },
  ]);

  const [form, setForm] = useState({ description: "", link: "" });
  const [editId, setEditId] = useState(null);

  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // ✅ Table columns
  const columns = [
    { header: "Description", key: "description" },
    { header: "Link", key: "link" },
    {
      header: "Action",
      key: "action",
      className: "actions-header",
      style: { width: "140px" }
    }
  ];

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAddOrUpdate = () => {
    if (!form.description || !form.link) return;

    if (editId) {
      setLinks(
        links.map((item) =>
          item.id === editId ? { ...item, ...form } : item
        )
      );
      setEditId(null);
    } else {
      setLinks([...links, { id: Date.now(), ...form }]);
    }

    setForm({ description: "", link: "" });
  };

  const handleEdit = (item) => {
    setForm({ description: item.description, link: item.link });
    setEditId(item.id);
  };

  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowConfirm(true);
  };

  const handleDelete = () => {
    setLinks(links.filter((item) => item.id !== deleteId));
    setShowConfirm(false);
    setDeleteId(null);
  };

  // ✅ renderRow for reusable table
  const renderRow = (item) => (
    <>
      <td>{item.description}</td>

      <td>
        <a href={item.link} target="_blank" rel="noreferrer">
          {item.link}
        </a>
      </td>

      <td>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleEdit(item);
          }}
        >
          Edit
        </button>

        <button
          onClick={(e) => {
            e.stopPropagation();
            confirmDelete(item.id);
          }}
          style={{ marginLeft: "8px", color: "red" }}
        >
          Delete
        </button>
      </td>
    </>
  );

  return (
    <div style={{ padding: "30px" }}>
      <Header title="Important Links" />

      {/* Form */}
      <div style={{ display: "flex", gap: "10px", margin: "20px 0" }}>
        <input
          name="description"
          placeholder="Description"
          value={form.description}
          onChange={handleChange}
        />

        <input
          name="link"
          placeholder="https://example.com"
          value={form.link}
          onChange={handleChange}
        />

        <button onClick={handleAddOrUpdate}>
          {editId ? "Update" : "Add"}
        </button>
      </div>

      {/* ✅ Reusable Table */}
      <Table
        columns={columns}
        data={links}
        renderRow={renderRow}
      />

      {/* Confirmation Popup */}
      {showConfirm && (
        <div style={overlayStyle}>
          <div style={popupStyle}>
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to delete this link?</p>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <button onClick={() => setShowConfirm(false)}>
                Cancel
              </button>

              <button
                onClick={handleDelete}
                style={{ background: "red", color: "#fff" }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const popupStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "6px",
  width: "300px",
};

export default ImpLink;
